
<div class="field" *ngIf="field" [class.empty]="!field.content &amp;&amp; !field.rasterized"><span class="inid">{{ field.code || '-' }}</span><span class="label">{{ field.label }}</span>
  <div class="rasterized" *ngIf="field.rasterized; else content"><img [src]="field.rasterized"></div>
  <ng-template #content>
    <div class="content" [innerHTML]="field.content" [class.hasEllipsis]="hasEllipsis" [class.isExpanded]="isExpanded || (ms &amp;&amp; ms.isLoading)" (click)="isExpanded=!isExpanded"></div>
  </ng-template>
</div>
